import AnalogCharacter from "./AnalogCharacter";

export default function AnalogCharacters({
  characters,
  fontSize,
  gap,
}: {
  characters: string;
  fontSize: string;
  gap?: string;
}) {
  return (
    <div
      style={{ display: "flex", gap: gap }}
      dir="ltr"
      aria-label={characters}
      role="img"
    >
      {characters.split("").map((character, index) => (
        <div key={index} aria-hidden={true}>
          <AnalogCharacter character={character} fontSize={fontSize} />
        </div>
      ))}
    </div>
  );
}
